import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { ContentService } from '../../services/content.service';
import { AbstractControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { Router } from '@angular/router';
import { CiamService } from 'src/app/services/CIAM/ciam.service';
import { PsqServiceService } from 'src/app/services/commonService/psq-service.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { AuthService } from '@auth0/auth0-angular';
import { jwtDecode } from 'jwt-decode';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { OtpRequestPayload } from 'src/app/models/interface/Registration/registration';
import { EmailVerificationComponent } from 'src/app/modules/registration/components/email-verification/email-verification.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/shared/common/common.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { RsaService } from 'src/app/services/commonService/rsa.service';
import { NgIf } from '@angular/common';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  imports: [ReactiveFormsModule, NgIf, MatFormField, MatLabel, MatInput, MatIconButton, MatSuffix, MatIcon, MatError, MatButton, MatProgressSpinner]
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  content: any;
  changePasswordForm!: FormGroup;
  isPasswordUpdated = false;
  showOldPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  showUpdatedPassword = false;
  verifyPassword = false;

  updatedPassword = '';

  isSpinner = false;
  companySettingDetails: any = {};
  // isProfileViewRestricted: boolean = false;

  constructor(private readonly contentService: ContentService, private readonly fb: FormBuilder, private readonly _CamApiService: CamService,
    private readonly toasterApiService: ToastrApiService, private readonly router: Router, private readonly _CiamService: CiamService,
    private readonly psqService: PsqServiceService, private readonly camService: CamService, private readonly crypto: CryptoService, private readonly _ToastrApiService: ToastrApiService,
    private readonly dictionaryContentService: DisctionaryContent, private readonly auth: AuthService, private readonly _MatDialog: MatDialog, private readonly commonService: CommonService,
    private _companyManagementService: CompanyManagementService,
    private rsaService: RsaService) {

  }
  ngOnInit() {
    try {
      const QlAccessToken = localStorage.getItem('QlAccessToken');
      if (QlAccessToken) {
        const decoded: any = jwtDecode(QlAccessToken);
        const isFederated = decoded?.IsFederatedAccount === 'True' || decoded?.isFederatedAccount === 'True';
        if (isFederated) {
          this.router.navigate(['/Dashboard']);
          return;
        }
      }
    } catch (e) {
      console.error('Error decoding token in ChangePasswordComponent', e);
    }

    combineLatest({
      content: this.contentService.content$, dictionary: this.dictionaryContentService.content$
    }).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = {
        ...res.content,
        dictionary: res.dictionary
      }
    });
    const stored = localStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS) ?? sessionStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS);
    this.companySettingDetails = stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    // const travelerGUID = localStorage.getItem('travelerGUID')?.toLowerCase();
    // const userGuid = localStorage.getItem('userGuid')?.toLowerCase();
    // this.isProfileViewRestricted = this.companySettingDetails?.restrictAmendmentInTravelerProfile && (travelerGUID !== userGuid);

    this.changePasswordForm = this.fb.group({
      oldPassword: [''],
      password: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(8), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/)]],
      confirmPassword: ['', [Validators.required, this.passwordMatchValidator.bind(this)]]
    });
    // if (this.isProfileViewRestricted) {
    //   this.changePasswordForm.disable();
    // }

    this.changePasswordForm.get('password')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.changePasswordForm.get('confirmPassword')?.updateValueAndValidity();
      });

    this._companyManagementService.page_landingChangePassword('Dashboard');
  }

  updatePassword() {
    this._companyManagementService.changeTraveler_management('Save', 1);
    const LoginEmail = this.crypto.getValueFromKey('LOGINNAME') as string;
    const payload: OtpRequestPayload = {
      type: 'email',
      otpAction: "mobileOrEmailValidation",
      value: LoginEmail.toLowerCase(),
      channel: 'email',
      companyId: "SAA",
      b2BId: null,
      b2BUserId: null,
      eventName: "DocumentUpdate"
    };

    this._CamApiService.sendOTP(payload).then((res: any) => {
      const checksum = res.data.checksum
      this.isSpinner = false;

      const dialogRef = this._MatDialog.open(EmailVerificationComponent, {
        data: {
          data: this.changePasswordForm.value,
          Email: this.crypto.getValueFromKey('LOGINNAME')?.toLowerCase() as string,
          verifyMode: 'email',
          otpChecksum: checksum,
          actionType: 'DocumentAdd',
          panelClass: 'custom-passport-dialog'
        }
      })

      dialogRef.afterClosed().subscribe((result: string) => {
        if (result == 'verified') {
          this.verifyPassword = true
          this.OtpVerifiedUpdatepassword();
        }
      });

    }).catch((error: any) => {
      const apiErrorCode = error?.error?.details?.[0]?.code;
      if (apiErrorCode === 'DUPLICATE_ENTRY') {
        this._ToastrApiService.show('error', 'OTP already sent. Please wait 30 seconds before trying again.')
      }
      this.isSpinner = false
      this._ToastrApiService.show('error', error?.error?.details?.[0]?.title);
      this._companyManagementService.view_error_messageChangePassword(error?.error?.details?.[0]?.title, 400)//GTM use
    })
  }

  OtpVerifiedUpdatepassword() {
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }
    this.isSpinner = true;
    const formValue = this.changePasswordForm.value;
    const encryptedPassword = this.rsaService.encrypt(formValue.password);
    const payload = {
      "password": encryptedPassword
    };

    const QlAccessToken = localStorage.getItem('QlAccessToken');
    const decoded: any = QlAccessToken ? jwtDecode(QlAccessToken) : null;
    const ciamID = decoded?.ciamId.trim();
    if (this.verifyPassword === true) {
      this.camService.ChangePassword(payload, ciamID).pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            this.isSpinner = false;
            if (res?.data?.updated_at || res?.data?.last_password_reset) {
              this.updatedPassword = formValue.password;
              this.isPasswordUpdated = true;
              this.changePasswordForm.reset();
              this.toasterApiService.show('success', 'Your password has been updated successfully!');
              this._companyManagementService.change_password_successChangePassword('Save', 'Success');
              setTimeout(() => {
                this.LogOut();
              }, 3000);

            }
            else {
              this.toasterApiService.show('error', 'Password update failed. Please try again.');
            }
          },
          error: (error: any) => {
            console.log('Error', error);
            this._companyManagementService.view_error_messageChangePassword(error.message, 400)//GTM use
            this.isSpinner = false;
            this.toasterApiService.show('error', 'Unable to update password. Please try later.');
          }
        })
    }
  }


  LogOut(): void {
    this.psqService.clearStoredData();
    this.auth.logout();
    this.commonService.triggerLogoutTab();
  }

  passwordMatchValidator(control: AbstractControl) {
    const confirmPassword = control.value;
    const password = this.changePasswordForm?.get('password')?.value;

    if (!password || !confirmPassword) {
      return null;
    }

    return password === confirmPassword ? null : { passwordMismatch: true };
  }


  onCancel() {
    this._companyManagementService.changeTraveler_management('Cancel', 1);
    this.changePasswordForm.reset();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
